import { render, staticRenderFns } from "./RoyaleScores.vue?vue&type=template&id=35c65acb&"
import script from "./RoyaleScores.vue?vue&type=script&lang=js&"
export * from "./RoyaleScores.vue?vue&type=script&lang=js&"
import style0 from "./RoyaleScores.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports